/*
METAS :
	accessRights: String => Code de droit d'accès (par ex, "MVP", ou "TRIGG")
	recurAccessRights: Boolean[default=false] => Indique que le accessRights prend également effet sur les routes enfants
	noLoggedIn: Boolean[default=false] => Indique que cette route est accessible uniquement sans authentification
	canAccessLoggedIn: Boolean[default=false] => Indique que la route est accessible qu'on soit connecté ou non
	needLoading: Boolean[default={noLoggedIn ? false : true}] => Indique que le route a besoin de passer par le chargement
*/

export default {
	routes: [
		{
			path: "/",
			name: "Home",
			component: () => import(/* webpackChunkName: "auth" */ "@/views/Home"),
			meta: {
				noLoggedIn: true
			}
        },
		{
			path: "/home",
			name: "HomeMenu",
			component: () => import(/* webpackChunkName: "shell" */ "@/views/HomeMenu"),
			meta: {
				accessRights: "MVP"
			}
        },
		{
			path: "/compte_creation",
			name: "CompteCreation",
			component: () => import(/* webpackChunkName: "auth" */ "@/views/CompteCreationV2"),
			props: (route) => ({cp: route.query.cp}),
			meta: {
				noLoggedIn: true,
			}
		},
		{
			path: "/ask_reset_password",
			name: "askResetPassword",
			component: () => import(/* webpackChunkName: "auth" */ "@/views/AskResetPassword"),
			meta: {
				noLoggedIn: true,
			}
		},
        {
			path: "/switch_tiers",
			name: "SwitchTiers",
			component: () => import(/* webpackChunkName: "shell" */ "@/views/SwitchTiers"),
			meta: {
				accessRights: "MVP"
			}
        },
        {
			path: "/loading",
			name: "Loading",
			component: () => import(/* webpackChunkName: "shell" */ "@/views/LoadingScreen"),
			props: true
        },
        {
			path: "/horse",
			name: "horseListe",
			component: () => import(/* webpackChunkName: "horse" */ "@/views/HorseListe"),
			meta: {
				accessRights: "CAHRS"
			}
		},
        {
			path: "/mare",
			name: "mareListe",
			component: () => import(/* webpackChunkName: "horse" */ "@/views/MareListeV2"),
			meta: {
				accessRights: "CAMARE"
			}
		},
		{
			path: "/acte_liste",
			name: "acteListe",
			component: () => import(/* webpackChunkName: "acte" */ "@/views/ActeListe"),
			meta: {
				accessRights: "CAACTE"
			}
		},
		{
			path: "/horse_ajout/",
			name: "horseAjout",
			component: () => import(/* webpackChunkName: "horse" */ "@/views/HorseAjoutBeta"),
			meta: {
				accessRights: "MVP"
			}
		},
		{
			path: "/horse_creation",
			name: "horseCreation",
			component: () => import(/* webpackChunkName: "horse" */ "@/views/HorseCreation"),
			meta: {
				accessRights: "MVP"
			}
		},
		{
			path: "/horse/:horse_id",
			name: "horseFiche",
			component: () => import(/* webpackChunkName: "horse" */ "@/views/HorseFiche"),
			meta: {
				accessRights: "MVP"
			},
			children: [
				{
					path: "horse_informations/",
					name: "HorseFicheInfo",
					component: () => import(/* webpackChunkName: "horse" */ "GroomyRoot/components/Horse/InformationsHorse"),
					props: true,
					meta: {
						accessRights: "MVP"
					}
				},
                {
					path: "horse_informations_tiny/",
					name: "HorsePedigreePdf",
					component: () => import(/* webpackChunkName: "horse" */ "@/components/Dedicated/Horse/InformationsHorse"),
					props: true,
					meta: {
						accessRights: "MVP"
					}
				},
				{
					path: "horse_actes/",
					name: "HorseFicheActes",
					component: () => import(/* webpackChunkName: "horse" */ "@/components/Horse/HorseActes"),
					props: true,
					meta: {
						accessRights: "CAACTE"
					}
				},
                {
					path: "horse_notes/",
					name: "HorseFicheNotes",
					component: () => import(/* webpackChunkName: "horse" */ "@/components/Notes/List"),
                    props: (route) => ({
                        horse_id: route.params.horse_id
                    }),
					meta: {
						accessRights: "MVP"
					}
				},
				{
					path: "monte_jument/",
					name: "ContractMareList",
					component: () => import(/* webpackChunkName: "horse" */ "@/components/Horse/ContractMare"),
					props: true,
					meta: {
						accessRights: "MVP"
					}
				},
				{
					path: "monte_jument/:contract_id",
					name: "ContractMareFiche",
					component: () => import(/* webpackChunkName: "horse" */ "@/components/Contract/ContractFicheHorse"),
					props: true,
					meta: {
						accessRights: "MVP"
					}
				},
				{
					path: "horse_product/",
					name: "HorseProduct",
					component: () => import(/* webpackChunkName: "horse" */ "@/components/Horse/HorseProduct"),
					props: true,
					meta: {
						accessRights: "MVP",
						onlineOnly: true
					}
				},
                {
					path: "horse_product_dedicated/",
					name: "HorseProductDedicated",
					component: () => import(/* webpackChunkName: "horse" */ "@/components/Dedicated/Horse/HorseProduct"),
					props: true,
					meta: {
						accessRights: "MVP",
						onlineOnly: true
					}
				},
                {
                    path: "horse_feed/",
                    name: "HorseFeed",
                    component: () => import(/* webpackChunkName: "horse" */ "@/components/Dedicated/Notes/Feed"),
					props: true,
					meta: {
						accessRights: "CAFLA",
						onlineOnly: true
					}
                },
                {
                    path: "horse_monte_infos/",
                    name: "HorseMonteInfo",
                    component: () => import(/* webpackChunkName: "horse" */ "@/components/Dedicated/Horse/InfosMonte"),
					props: true,
					meta: {
						accessRights: "CAMI",
						onlineOnly: true
					}
                },
                {
                    path: "horse_perfs/",
                    name: "HorsePerfs",
                    component: () => import(/* webpackChunkName: "horse" */ "@/components/Dedicated/Horse/HorsePerfs"),
					props: true,
					meta: {
						accessRights: "CAPR",
						onlineOnly: true
					}
                },
                {
                	path: "pax/st=:stallion_ids?/fc=:filtre_categories?/fp=:filtre_prix?",
                    name: "HorsePax",
                    component: () => import(/* webpackChunkName: "pax" */ "@/components/Horse/Pax"),
					props: true,
					meta: {
						accessRights: "CAPAX",
						onlineOnly: true
					}
                },
                {
                	path: "pax_suggestion/",
                    name: "HorsePaxSuggestion",
                    component: () => import(/* webpackChunkName: "pax" */ "@/components/Horse/PaxSuggestion"),
					props: true,
					meta: {
						accessRights: "CAPAX",
						onlineOnly: true
					}
                },
                {
                	path: "croissance/",
                    name: "HorseSuiviCroissance",
                    component: () => import(/* webpackChunkName: "horse" */ "@/components/Horse/HorseCroissance"),
					props: true,
					meta: {
						accessRights: "SVCROI",
						onlineOnly: true
					}
                },
                {
                	path: "croissance/cr=:croissance_id?",
                    name: "AddHorseCroissance",
                    component: () => import(/* webpackChunkName: "horse" */ "@/components/Horse/AddHorseCroissance"),
					props: true,
					meta: {
						accessRights: "SVCROI",
						onlineOnly: true
					}
                },
                {
                	path: "croissance/compare",
                    name: "HorseCroissanceGraph",
                    component: () => import(/* webpackChunkName: "horse" */ "@/components/Horse/HorseCroissanceGraph"),
					props: true,
					meta: {
						accessRights: "SVCROI",
						onlineOnly: true
					}
                },
                {
                	path: "mouvements/",
                    name: "HorseMouvements",
                    component: () => import(/* webpackChunkName: "horse" */ "@/components/Horse/Mouvements"),
					props: true,
					meta: {
						accessRights: "CAMVT",
						onlineOnly: true
					}
                },
                {
					path: "semence/",
					name: "StallionSemence",
					component: () => import(/* webpackChunkName: "semence" */ "@/components/Semence/Stallion"),
					props: true,
					meta: {
						accessRights: "CASMNC",
						onlineOnly: true
					},
					children: [
						{
							path: "stocks/",
							name: "StallionStocks",
							component: () => import(/* webpackChunkName: "semence" */ "@/components/Semence/StallionStocks"),
							props: true
						},
						{
							path: "commandes/",
							name: "StallionCommandes",
							component: () => import(/* webpackChunkName: "semence" */ "@/components/Semence/StallionCommandes"),
							props: true
						},
						{
							path: "expeditions/",
							name: "StallionExpeditions",
							component: () => import(/* webpackChunkName: "semence" */ "@/components/Semence/StallionExpeditions"),
							props: true
						},
					]
				},
                {
                	path: "tiers_contacts/",
                    name: "HorseTiersContact",
                    component: () => import(/* webpackChunkName: "horse" */ "@/components/Horse/TiersContact"),
					props: true,
					meta: {
						accessRights: "CATCHRSE",
						onlineOnly: true
					}
                }
			]
		},
		{
			path: "/addressed_invoices",
			name: "addressedInvoices",
			component: () => import(/* webpackChunkName: "invoice" */ "@/views/InvoicesAddressed"),
			meta: {
				accessRights: "CAFACT"
            }
        },
        {
			path: "/addressed_payments",
			name: "addressedPayments",
			component: () => import(/* webpackChunkName: "invoice" */ "@/views/PaymentsAddressed"),
			meta: {
				accessRights: "CAFACT|CAREGL"
            }
		},
		{
			path: "/addressed_quotations",
			name: "addressedQuotations",
			component: () => import(/* webpackChunkName: "invoice" */ "@/views/QuotationsAddressed"),
			meta: {
				accessRights: "CADEVIS"
            }
        },
        {
			path: "/payment_methods",
			name: "paymentMethods",
			component: () => import(/* webpackChunkName: "invoice" */ "@/views/PaymentMethods"),
			meta: {
				accessRights: "CAREGL",
                recurAccessRights: true
            },
            children: [
		        {
					path: "add/",
					name: "AddPaymentMethod",
					component: () => import(/* webpackChunkName: "invoice" */ "GroomyRoot/components/Marketplace/PaymentMethodsAdd"),
				},
				{
					path: "list/",
					name: "paymentMethodList",
					component: () => import(/* webpackChunkName: "invoice" */ "GroomyRoot/components/Marketplace/PaymentMethodsList"),
                    meta: {
                        accessRights: "CAREGL&MANG"
                    }
				},
            ]
		},
		{
			path: "/valid_email/tk=:token?/sg=:signature?/em=:email?/uid=:userid?/lg=:lang?",
			name: "EmailValidation",
			component: () => import(/* webpackChunkName: "auth" */ "@/views/EmailValidation"),
			meta: {
				noLoggedIn: true,
				canAccessLoggedIn: true
			}
		},
        {
        	path: '/monte/contrats',
        	name: 'ContractList',
        	component: () => import(/* webpackChunkName: "contract" */ '@/components/Contract/ContractList'),
			meta: {
				accessRights: "CASAILL"
			},
        },
        {
        	path: '/monte/contrats/new/:stallion_id?/:mare_id?',
        	name: 'ContractNew',
        	component: () => import(/* webpackChunkName: "contract" */ '@/components/Contract/ContractNew'),
			meta: {
				accessRights: "CASAILL"
			},
        },
        {
        	path: '/payment-result/:type?/:ids?',
        	name: 'PaymentResult',
        	component: () => import(/* webpackChunkName: "payment" */ '@/components/Payment/PaymentResult'),
        	meta: {
        		accessRights: "CASAILL|CAFACT|CAREGL"
        	},
        },
        {
			path: "/notes",
			name: "notes",
			component: () => import(/* webpackChunkName: "notes" */ "@/views/NotesListe"),
			meta: {
				accessRights: "CANOTE"
			},
		},
        {
			path: "/note_fiche/n_id=:note_id",
			name: "notesManagement",
			component: () => import(/* webpackChunkName: "notes" */ "@/views/NoteFiche"),
			meta: {
				accessRights: "CANOTE"
			},
		},
        {
			path: "/feed",
			name: "feed",
			component: () => import(/* webpackChunkName: "dedicated" */ "@/views/Dedicated/Feed"),
			meta: {
				accessRights: "CAFLA"
			},
		},
        {
			path: "/effectif",
			name: "effectif",
			component: () => import(/* webpackChunkName: "dedicated" */ "@/views/Dedicated/Effectif"),
			meta: {
				accessRights: "CALE"
			},
		},
        {
			path: "/partants",
			name: "partants",
			component: () => import(/* webpackChunkName: "dedicated" */ "@/views/Dedicated/Partants"),
			meta: {
				accessRights: "CAPR"
			},
		},
        {
			path: "/resultats",
			name: "resultats",
			component: () => import(/* webpackChunkName: "dedicated" */ "@/views/Dedicated/Resultats"),
			meta: {
				accessRights: "CAPR"
			},
		},
		{
			path: "/display_settings",
			name: "displaySettings",
			component: () => import(/* webpackChunkName: "shell" */ "@/views/DisplaySettings"),
			meta: {
				accessRights: "MVP",
				onlineOnly: true,
			}
		},
		{
			path: "/switch_lang",
			name: "switchLang",
			component: () => import(/* webpackChunkName: "shell" */ "@/views/SwitchLang"),
			meta: {
				accessRights: "MVP",
				onlineOnly: true,
			}
		},
		{
			path: "/reset_password",
			name: "resetPassword",
			component: () => import(/* webpackChunkName: "shell" */ "@/views/ResetPassword"),
			meta: {
				accessRights: "MVP",
				onlineOnly: true,
			}
		},
		{
			path: "/update_password/:token/:email",
			name: "PasswordUpdate",
			component: () => import(/* webpackChunkName: "auth" */ "@/views/UpdatePassword"),
			meta: {
				noLoggedIn: true,
				onlineOnly: true,
			}
		},
		{
			path: "/pax/home",
			name: "paxHome",
			component: () => import(/* webpackChunkName: "pax" */ "@/views/PaxHome"),
			meta: {
				accessRights: "CAPAX",
				onlineOnly: true,
			}
		},
		{
			path: "/pax/reverse",
			name: "paxReverse",
			component: () => import(/* webpackChunkName: "pax" */ "@/views/PaxReverse"),
			meta: {
				accessRights: "CAPAX",
				onlineOnly: true
			}
		},
		{
			path: "/pax/suggestion",
			name: "paxSuggestion",
			component: () => import(/* webpackChunkName: "pax" */ "@/views/PaxSuggestion"),
			meta: {
				accessRights: "CAPAX",
				onlineOnly: true
			}
		},
		{
			path: "/pax/st=:stallion_ids?/m_id=:mare_id?",
			name: "pax",
			component: () => import(/* webpackChunkName: "pax" */ "@/views/Pax"),
			meta: {
				accessRights: "CAPAX",
				onlineOnly: true,
			}
		},
		{
			path: "/expeditions",
			name: "expeditions",
			component: () => import(/* webpackChunkName: "semence" */ "@/views/Expeditions"),
			meta: {
				accessRights: "DMNEXP",
				onlineOnly: true,
			}
		},
		{
			path: "/gocardless",
			name: "gocardless",
			component: () => import(/* webpackChunkName: "gocardless" */ "@/views/Gocardless"),
			meta: {
				accessRights: "CAREGL&GOCAR",
				onlineOnly: true,
			},
            children: [
		        {
					path: "bank_account/",
					name: "gocardlessBankAccount",
					component: () => import(/* webpackChunkName: "gocardless" */ "@/components/Gocardless/BankAccount"),
				},
				{
					path: "mandate/",
					name: "gocardlessMandate",
					component: () => import(/* webpackChunkName: "gocardless" */ "@/components/Gocardless/Mandate"),
				},
				{
					path: "payment/",
					name: "gocardlessPayment",
					component: () => import(/* webpackChunkName: "gocardless" */ "@/components/Gocardless/Payment"),
				},
            ]
		},
		{
			path: "/pax_express",
			name: "PaxExpress",
			component: () => import(/* webpackChunkName: "pax" */ "@/views/PaxExpress"),
			meta: {
				noLoggedIn: true
			}
        },
		{
			path: "/mouvements",
			name: "mouvements",
			component: () => import(/* webpackChunkName: "horse" */ "@/views/Mouvements"),
			meta: {
				accessRights: "CAMVT",
				onlineOnly: true,
			},
        },
		{
			path: "/semence",
			name: "semence",
			component: () => import(/* webpackChunkName: "semence" */ "@/views/Semence"),
			meta: {
				accessRights: "CASMNC",
				onlineOnly: true,
			},
			children: [
				{
					path: "stallions",
					name: "semenceStallions",
					component: () => import(/* webpackChunkName: "semence" */ "@/components/Semence/Stallions"),
				},
				{
					path: "commandes_non_traitrees",
					name: "semenceCommandesNonTraitees",
					component: () => import(/* webpackChunkName: "semence" */ "@/components/Semence/Commandes"),
					props: () => ({
						status: [1]
					}),
				},
				{
					path: "commandes_non_expediees",
					name: "semenceCommandesNonExpediees",
					component: () => import(/* webpackChunkName: "semence" */ "@/components/Semence/Commandes"),
					props: () => ({
						status: [2,3,4]
					}),
				},
				{
					path: "expeditions",
					name: "semenceExpeditions",
					component: () => import(/* webpackChunkName: "semence" */ "@/components/Semence/Expeditions"),
				}
			]
        },
		{
			path: "/contact",
			name: "contactUs",
			component: () => import(/* webpackChunkName: "shell" */ "@/views/ContactUs"),
			meta: {
				accessRights: "MVP",
				onlineOnly: true,
			}
		},
    ]	
}
